import React, { useState } from "react";
import AutoComplete from "@mui/material/Autocomplete";
import CustomGlobalSearchTextField from "../customMUIComponents/CustomGlobalSearchTextField";
import { SocietyDTO } from "../../context/SocietyProvider";

interface GlobalSearchProps {
    societies: SocietyDTO[],
}

const SocietySearchBar = ({ societies }: GlobalSearchProps) => {

    const [societySearch, setSocietySearch] = useState<string>('');

    return (
        <AutoComplete
            onChange={(e, value) => {
                for (const society of societies
                    .filter((society1) => society1.name !== undefined)) {
                    if (society.name!.includes(value)) {
                        window.open(`https://${society.subdomain}.looty.ch`, '_blank');
                        break;
                    }
                }
            }}

            onKeyUp={(event) => {
                if (societySearch && event.key === 'Enter') {
                    //TODO maybe nothing to do
                }
            }}

            filterOptions={(societiesNames, state) => {
                return societiesNames
                    .filter((societyName) => societyName !== undefined)
                    .filter((societyName) => {
                        return societyName!.toLowerCase()
                            .normalize('NFD')
                            .replace(/\p{Diacritic}/gu, '')
                            .includes(
                                state.inputValue.toLowerCase()
                                    .normalize('NFD')
                                    .replace(/\p{Diacritic}/gu, '')
                            );
                    });
            }}
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            options={societySearch ? societies.map((society) => society.name) : []}
            renderInput={(params) => (
                <CustomGlobalSearchTextField setField={setSocietySearch} params={params} />
            )}
            slotProps={{
                paper: {
                    sx: {
                        marginLeft: '15px',
                        marginRight: '15px',
                    }
                }
            }}
        />
    );
}

export default SocietySearchBar